import EventBus from './EventBus';
import EventBusEvent from './EventBusEvent';
// eslint-disable-next-line import/no-cycle
import EventBusWrapper from './EventBusWrapper';

const eventBus = new EventBus();
const useEventBus = () => ({ eventBus });

export { EventBus, EventBusEvent, EventBusWrapper, useEventBus };
